import React, { useState, useEffect, useRef } from 'react';
import { Button, Spin, Empty, Pagination, message, Popover } from 'antd';
import { useHistory } from 'react-router-dom';
import { FolderViewOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import NewMessage from '../../component/newMessage/newMessage';

import './studentAssignments.css'
import AssignmentModal from './assignmentModal';
import upload from '../../public/img/newMain/upload.png'
import submit2 from '../../public/img/newMain/submit2.png'
import deleteblue from '../../public/img/newMain/deleteblue.png'
import replaceblue from '../../public/img/newMain/replaceblue.png'
import MessageTwoImage3 from '../../component/messageTwoImage/messageTwoImage3';
import { studentCheckLogin } from '../newMain/studentMain';
import moment from 'moment';//日期格式化导包
import turnitinImg from '../../public/img/newMain/turnitinImg.png';
import UploadDocumentModal from './uploadDocumentModal';
import DeleteFileModal from './deleteFileModal';
import ReplaceConfireModal from './replaceConfireModal';
import SubmitFileModal from './submitFileModal';

const StudentAssignments = (props) => {

    const studentModuleId = localStorage.getItem(Config.tokenPrefix + 'studentModuleId');
    const messageRef = useRef();
    const messageRef2 = useRef();
    const history = useHistory();
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(9);
    const searchModel = useRef({});
    const [isApprove, setIsApprove] = useState(false);
    const [isUploadDocumentModal, setIsUploadDocumentModal] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const deleteFileMessageRef = useRef();
    const submitFileMessageRef = useRef();
    const replaceConfireRef = useRef();
    const [isAssignmentModal, setIsAssignmentModal] = useState(false);
    const [studentModuleModel, setStudentModuleModel] = useState({});
    const [studentModuleAssignModel, setStudentModuleAssignModel] = useState({});
    const [formData, setFormData] = useState(null);
    const [editFlag, setEditFlag] = useState('add');

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchModuleById();
        search(pageSize, current);
    }, []);

    useEffect(() => {
        // 设置定时任务，隔一分钟执行一次
        const intervalId = setInterval(() => {
            search(pageSize, current); // 每次间隔触发时调用 search
        }, 60000);
        // 在组件卸载时清理定时器
        return () => {
          clearInterval(intervalId);
        };
        // 依赖于 pageSize 和 current，确保它们变化时重新设置定时器
    }, [pageSize, current]);

    const searchModuleById = () => {
        let model = {studentModuleId: studentModuleId};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setStudentModuleModel(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const searchChange = (key, value) => {
        searchModel.current = { ...searchModel.current, ...{ [key]: value } };
        search(pageSize, 1)
    }

    const search = (pageSizeNew, currentPageNew) => {
        let model = {...searchModel.current, studentModuleId: studentModuleId, studentId : Config.studentInfo?.studentId};
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        Base.callBackApi("assign/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { });
    }
    
    const openUploadDocument = (flag, model) => {
        setEditFlag(flag);
        setStudentModuleAssignModel(model);
        setIsUploadDocumentModal(true)
    }

    const closeUploadDocument = (flag, formData) => {
        setIsUploadDocumentModal(false)
        if (flag) {
            setFormData(formData);
            replaceConfireShow();
        }
    }

    const replaceConfireShow = () => {
        replaceConfireRef.current.setContent("Please confirm that you wish to upload the selected assignment. ")
        replaceConfireRef.current.setIsShow(true)
    }

    const replaceConfire = (flag) => {
        replaceConfireRef.current.setIsShow(false)
        if (flag) {
            if (isLoad) {
                return;
            }
            setIsLoad(true);
            Base.callBackUploadApi('assign/update', formData).then((data) => {
                if ("SUCCESS" === data.msg) {
                    let model = data?.object ?? {};
                    if (model?.turnitinReqInd == 'Y') {
                        errFrameShow('Assignment successfully uploaded. Please press "Submit" to officially submit it. The assignment has been sent to Turnitin for a similarity check. Please note that it may take some time for Turnitin to provide the results. You can review the similarity score later using the "Turnitin" button.', true, true);
                    } else {
                        errFrameShow('Assignment successfully uploaded. Please press "Submit" to officially submit it.');
                    }
                } else {
                    message.error(data.msg);
                    search(pageSize, current);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    /** 生成提示信息 */
    const errFrameShow = (msg, flag = true, textJustifyFlag = false) => {
        messageRef.current.setContent(msg);
        messageRef.current.setIsShow(true);
        messageRef.current.setStatusFlag(flag);
        messageRef.current.setTextJustifyFlag(textJustifyFlag);
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        search(pageSize, current);
    }

    const jump = (path) => {
        history.push(path)
    }

    const done2 = () => {
        setIsApprove(true)
        messageRef2.current.setIsShow(false)
    }

    const deleteFile = (flag) => {
        deleteFileMessageRef.current.setIsShow(false)
        if (flag) {
            setIsLoad(true);
            Base.callBackApi("assign/delete", studentModuleAssignModel).then((data) => {
                if ("SUCCESS" === data.msg) {
                    errFrameShow("You have deleted the selected assignment successfully.")
                } else {
                    message.error(data.msg)
                    search(pageSize, current);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const deleteFileShow = (model) => {
        setStudentModuleAssignModel(model);
        deleteFileMessageRef.current.setContent("Please confirm you wish to delete the file?")
        deleteFileMessageRef.current.setIsShow(true)
    }

    const submitFile = (flag) => {
        submitFileMessageRef.current.setIsShow(false)
        if (flag) {
            setIsLoad(true);
            Base.callBackApi("assign/updateStatus", studentModuleAssignModel).then((data) => {
                if ("SUCCESS" === data.msg) {
                    let model = data?.object ?? {};
                    if (model?.turnitinReqInd == 'Y') {
                        errFrameShow(`You have successfully submitted the selected assignment. Please note that the assignment status has changed to "Submitted," and editing is no longer allowed. Additionally, the assignment has been sent to Turnitin for a similarity check. You can review the similarity score later by using the "Turnitin" button.`, true, true)
                    } else {
                        errFrameShow(`You have successfully submitted the selected assignment. Please note that the assignment status has changed to "Submitted," and editing is no longer allowed.`)
                    }
                } else {
                    message.error(data.msg)
                    search(pageSize, current);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const submitFileShow = (model) => {
        setStudentModuleAssignModel(model);
        submitFileMessageRef.current.setIsShow(true)
    }

    const openAssignmentModal = (model) => {
        setStudentModuleAssignModel(model);
        setIsAssignmentModal(true);
    }

    const closeAssignmentModal = (flag, score) => {
        setIsAssignmentModal(false);
    }

    const turnitin = (model) => {
        if (isLoad) {
            return;
        }
        if (model?.submissionStatus == 'ERROR') {
            errFrameShow(ContextHandler.getMapValue('turnitinErrorCodeMap', model?.submissionErrorCode) + ` Please click "Replace" to replace the current assignment and retrigger the Turnitin similarity check, or click "Delete" to remove the current assignment. After deleting, click "Upload" to upload a new assignment to trigger the Turnitin similarity check.`, false, true);
            return;
        }
        setIsLoad(true);
        Base.callBackApi('assign/turnitin', model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let m = data?.object ?? {};
                if(m?.turnitinUrl) {
                    window.open(m.turnitinUrl, '_blank');
                }
                search(pageSize, current);
            } else {
                message.error(data.msg);
                search(pageSize, current);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
    
    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    return (
        <div id="container" className='websiteTemplate studentAssignments'>
            {isAssignmentModal && <AssignmentModal onClose={closeAssignmentModal} studentModuleAssignModel={studentModuleAssignModel} />}
            <DeleteFileModal ref={deleteFileMessageRef} done={deleteFile} />
            <ReplaceConfireModal ref={replaceConfireRef} done={replaceConfire} />
            <SubmitFileModal ref={submitFileMessageRef} done={submitFile} />
            <NewMessage ref={messageRef} done={done} />
            <MessageTwoImage3 ref={messageRef2} done={done2} />
            {isUploadDocumentModal && <UploadDocumentModal onClose={closeUploadDocument} studentModuleAssignModel={studentModuleAssignModel} editFlag={editFlag}/>}
            <Spin size="large" spinning={isLoad} >
                <div className='topBox'>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle">
                            Assignments
                        </div>
                    </div>
                    <div className='moduleBox'>
                        <div className='moduleBoxCenter'>
                            <div>
                                <div className='cardSubTitle'>{studentModuleModel?.moduleCode}</div>
                                <div className='cardSubTitle'>{studentModuleModel?.moduleName}</div>
                                <div className='flexBox'>
                                    <div className='label'>Student Name</div>
                                    <div className='value'>{studentModuleModel?.firstName && studentModuleModel?.lastName && studentModuleModel?.firstName + ' ' + studentModuleModel?.lastName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Student ID</div>
                                    <div className='value'>{studentModuleModel?.studentAcctId}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Programme</div>
                                    <div className='value'>{studentModuleModel?.progTitle}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Cohort Year</div>
                                    <div className='value'>{studentModuleModel?.cohortYear}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Assigned Academic Supervisor</div>
                                    <div className='value'>{studentModuleModel?.academicSupervisorUserName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Module Convener</div>
                                    <div className='value'>{studentModuleModel?.moduleConvenerName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Student Record Status</div>
                                    <div className='value'>{ContextHandler.getMapValue('studentModuleStatusMap', studentModuleModel?.status)}</div>
                                </div>
                            </div>
                            <div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>WIL Hours</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Total Curriculum Hours</div>
                                    <div className='value '>{studentModuleModel?.curriculumHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Other Learning Activities Hours</div>
                                    <div className='value '>{studentModuleModel?.otherLearningTrainingHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Exempted</div>
                                    <div className='value '>{studentModuleModel?.exemptedHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Needed</div>
                                    <div className='value '>{studentModuleModel?.neededWilHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Completed</div>
                                    <div className='value '>{studentModuleModel?.completedWilHours} ({studentModuleModel?.neededWilHours > 0 ? Base.parseToPercent(studentModuleModel?.completedWilHours / studentModuleModel?.neededWilHours) : 100}%)</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA in progress</div>
                                    <div className='value '>{studentModuleModel?.inProgressWpaCount}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA status Sent to IP that is over 14 days</div>
                                    <div className='value '>{studentModuleModel?.sentToIsCount}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA Completed</div>
                                    <div className='value '>{studentModuleModel?.completedWpaCount}</div>
                                </div>
                            </div>
                            <div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>Assignments</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of Assignments submitted vs. target</div>
                                    <div className='value '>{studentModuleModel?.studentModuleAssignModelList ? studentModuleModel?.studentModuleAssignModelList?.filter(item => item.status == 'SUBMITTED')?.length + '/' + studentModuleModel?.studentModuleAssignModelList?.length : '0/0'}</div>
                                </div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>Marks</div>
                                </div>
                                {studentModuleModel?.studentModuleAssignModelList?.map(item =>
                                    <div className='flexBox ' key={item?.studentModuleAssignId}>
                                        <div className='label'>{item?.assignName} mark</div>
                                        <div className='value '>{item?.assignMarks == 0 ? '0/100' : (item?.assignMarks ? Base.parseToFixed(item?.assignMarks, 2) + '/100' : 'Incomplete')}</div>
                                    </div>
                                )}
                                <div className='flexBox '>
                                    <div className='label'>Total WPA mark</div>
                                    <div className='value '>{studentModuleModel?.wpaMarks == 0 ? '0/100' : (studentModuleModel?.wpaMarks ? Base.parseToFixed(studentModuleModel?.wpaMarks, 2) + '/100'  : 'N/A')}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Total Module Mark and grade</div>
                                    <div className='value '>{studentModuleModel?.totalModuleMark == 0 ? '0/100' : (studentModuleModel?.totalModuleMark ? Base.parseToFixed(studentModuleModel?.totalModuleMark, 2) + '/100 (' + Base.calcGrade(studentModuleModel?.totalModuleMark) + ')' : 'N/A')} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {Base.isEmpty(tables) ? <Empty /> : ''}
                <div className='seeAllCardBox'>
                    {
                        tables?.map(item => 
                            <div className={'allCardBoxDiv borderColor' + item?.status} key={item?.studentModuleAssignId}>
                                <div className='cardTitleBox'>
                                    <div className='cardTitle' title={item?.assignName}>{item?.assignName}</div>
                                    <div className={'statusBox ' + item?.status}>
                                        {ContextHandler.getMapValue('assignmentStatusMap', item?.status)}
                                    </div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label labelCircleBox'>
                                        Uploaded File
                                        <Popover placement="right" content={<div className='popoverContent'>
                                            - 1 file, max 10MB, recommended file type is .pdf.<br/>
                                            {`- Store large content (e.g., photos, videos) on the student's OneDrive or Panapto. Include links in the assignment for submission.`}<br/>
                                            - Upload: Supported types are .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt.<br/>
                                            - View: Non-PDF types may not be displayed or aligned correctly.<br/>
                                            - If assignment is Turnitin-flagged, the file cannot be Deleted/Replaced until Turnitin score is returned.
                                        </div>} trigger="hover">
                                            <div className='labelCircle'><InfoCircleOutlined /></div>
                                        </Popover>
                                    </div>
                                    <div className='value'>{item?.fileName ? item?.fileName : 'None'}</div>
                                </div>
                                {item?.turnitinReqInd == 'Y' && 
                                    <div className='flexBox'>
                                        <div className='label labelCircleBox'>
                                            Turnitin Score
                                            <Popover placement="right" content={<div className='popoverContent'>
                                                - xx% = similarity score from Turnitin.<br/>
                                                - N/A = no similarity score received from Turnitin.<br/>
                                                - Error = error detected by Turnitin.<br/>
                                            </div>} trigger="hover">
                                                <div className='labelCircle'><InfoCircleOutlined /></div>
                                            </Popover>
                                        </div>
                                        <div className='value'>{item?.submissionStatus == 'ERROR' ? 'Error, click “Turnitin” for detail.' :(item?.turnitinScore === 0? '0%' : item?.turnitinScore ? item?.turnitinScore + '%' : 'N/A')}</div>
                                    </div>
                                }
                                <div className='flexBox'>
                                    <div className='label'>Submitted Date</div>
                                    <div className='value'>{item?.submittedDate ? moment(item?.submittedDate).format(Config.dateFormatEn) : 'N/A'}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Last Edit Date</div>
                                    <div className='value'>{item?.lastUpdatedDate && moment(item?.lastUpdatedDate).format(Config.dateFormatEn)}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Deadline</div>
                                    <div className='value'>{item?.assignDeadline && moment(item?.assignDeadline).format(Config.dateFormatEn)}</div>
                                </div>
                                <div className='cardLine'></div>
                                <div className='cardButtonBox' >
                                    {item?.status != 'BLANK' && item.filePath && <Button icon={<FolderViewOutlined />} className='cardButton' onClick={() => openAssignmentModal(item)}>View</Button>}
                                    {(item?.status == 'WIP' || (item?.status == 'OVERDUE' && item?.filePath)) && <Button onClick={() => openUploadDocument('edit', item)} icon={<img src={replaceblue} />} className='cardButton'>Replace</Button>}
                                    {(item?.status == 'WIP' || (item?.status == 'OVERDUE' && item?.filePath)) && <Button onClick={() => deleteFileShow(item)} icon={<img src={deleteblue} />} className='cardButton'>Delete</Button>}
                                    {item?.status != 'BLANK' && item.filePath && item?.turnitinReqInd == 'Y' && <Button onClick={() => turnitin(item)} icon={<img src={turnitinImg} />} className='cardButton'>Turnitin</Button>}
                                    {(item?.status == 'BLANK' || (item?.status == 'OVERDUE' && !item?.filePath)) && <Button icon={<img src={upload} />} onClick={() => openUploadDocument('add', item)} className='cardButton'>Upload</Button>}
                                    {(item?.status == 'WIP' || (item?.status == 'OVERDUE' && item?.filePath)) && <Button onClick={() => submitFileShow(item)} icon={<img src={submit2} />} className='cardButton'>Submit</Button>}
                                </div>
                            </div>
                        )
                    }
                    </div>
                    {tablesCount > 9 && 
                        <div className="pagination">
                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={tablesCount}
                                itemRender={itemRender}
                                showSizeChanger={false}
                                onChange={onChange}
                            />
                        </div>
                    }
                    <div>
                </div>
            </Spin>
        </div>
    )

}

export default StudentAssignments;